export default __webpack_public_path__ + "static/media/incubation.c1e66e29.svg";